module.exports = __webpack_public_path__ + "img/taizhou_s.53f7f74.png";